import React from 'react';
import {
  flex,
  column,
  centerItems,
  centerContent,
  alignFlexEnd
} from 'scy/flex.mod.scss';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import classnames from 'classnames';
import logo from 'images/icon-144x144.png';
import { Body, Small, H2 } from 'scy/text';
import { secondary, accent, darkBgPrimary, h4 } from 'scy/text/styles.mod.scss';
import { width100, textCenter, linkText } from 'scy/utils.mod.scss';
import { PrimaryButton } from 'scy/buttons';
import { absolute, fixed, relative } from 'scy/position.mod.scss';
import ChevronDown from 'images/icons/controls/chevron-down.svg?react-svg';
import Star from 'images/icons/stars/full.svg?react-svg';
import CloseButton from 'images/icons/controls/close.svg?react-svg';
import styles from './styles.mod.scss';

const adjustLink = '//app.adjust.com/1jur2vf';
const InstallBanner = ({ handleMinimizeBanner }) => (
  <div className={classnames(relative, styles.bannerContainer)}>
    <Backdrop onClick={() => handleMinimizeBanner()} />
    <div
      className={classnames(
        styles.installBanner,
        flex,
        padding.sm,
        column,
        centerItems,
        centerContent
      )}
    >
      <ChevronDown
        className={classnames(styles.minimizeButton, absolute)}
        onClick={() => handleMinimizeBanner()}
      />
      <div className={classnames(flex, centerContent, alignFlexEnd)}>
        <img
          src={logo}
          className={classnames(styles.logo, margin.right_xs, padding.xs)}
          height={50}
          width={50}
        />
        <Rating />
      </div>
      <H2>Let&apos;s make this even easier:</H2>
      <BannerText />
      <CTAButton />
    </div>
  </div>
);

const BannerText = ({ handleMinimizeBanner, isLinkable }) => {
  return (
    <Body
      className={classnames(textCenter, {
        [padding.bottom_xs]: !isLinkable,
        [linkText]: isLinkable,
        [darkBgPrimary]: isLinkable
      })}
      onClick={() => (isLinkable ? handleMinimizeBanner() : () => {})}
    >
      Download the Saucey app &<br /> get
      <span className={classnames(h4, isLinkable ? styles.tertiary : accent)}>
        {` $5 off `}
      </span>
      your first order.
    </Body>
  );
};

const Rating = () => (
  <div>
    <div className={flex}>
      <Star />
      <Star />
      <Star />
      <Star />
      <Star />
    </div>
    <Small className={secondary}>24.4k Ratings</Small>
  </div>
);

const CTAButton = () => (
  <a href={adjustLink} className={width100}>
    <PrimaryButton className={width100}>get saucey</PrimaryButton>
  </a>
);

const InstallBannerMinimized = ({
  handleMinimizedBannerDismissed,
  handleMinimizeBanner
}) => (
  <div className={classnames(styles.installBannerMinimized, padding.sm)}>
    <div className={classnames(flex, column, centerContent, centerItems)}>
      <CloseButton
        style={style.closeButton}
        onClick={() => handleMinimizedBannerDismissed()}
      />

      <BannerText handleMinimizeBanner={handleMinimizeBanner} isLinkable />
    </div>
  </div>
);

const Backdrop = props => (
  <div className={classnames(styles.backdrop, fixed)} {...props} />
);

const style = {
  closeButton: {
    color: 'white',
    cursor: 'pointer',
    padding: '2px',
    position: 'absolute',
    right: '8px',
    top: '8px'
  }
};

export { InstallBanner, InstallBannerMinimized };
